import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "https://api2.pandora-ai.it/auth";

const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  config.headers = config.headers || {};
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Add header to bypass ngrok warning (development only)
  if (process.env.NODE_ENV === 'development') {
    config.headers['ngrok-skip-browser-warning'] = 'true';
  }
  return config;
});

// Intercept 401 responses and logout user
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
